<ng-container *ngIf="vm$ | async as vm">
  <div class="td-main-container" [ngClass]="{'is-loading': vm.loading}">
    <div class="td-header-container">
      <div class="td-header-info">
        <a *ngIf="userRoleWorkspacePriority >= 30" class="td-back" routerLink="/workspace-overview">
          <i class="bi bi-chevron-left"></i>
          <span>{{ 'report_back_to_workspace_overview' | translate }}</span>
        </a>
        <span class="td-header-title">{{ 'wo_team_dynamic_title' | translate }}</span>
      </div>
      <div class="td-header-tools">
        <div class="td-view-switch">
          <button type="button" class="td-view-switch-btn" [ngClass]="{'active': view === 'overall'}"
                  (click)="setView('overall')">
            <i class="bi bi-grid-1x2"></i>
            <span>{{ 'td_view_overall' | translate }}</span>
          </button>
          <button type="button" class="td-view-switch-btn" [ngClass]="{'active': view === 'indicator'}"
                  (click)="setView('indicator')">
            <i class="bi bi-bar-chart"></i>
            <span>{{ 'td_view_indicator' | translate }}</span>
          </button>
        </div>
        <p-dropdown #periodDropdown
                    [options]="periodOptions"
                    [(ngModel)]="period"
                    optionLabel="label" optionValue="value"
                    scrollHeight="auto"
                    dropdownIcon="bi bi-caret-down-fill"
                    styleClass="wo-dropdown"
                    panelStyleClass="wo-dropdown-panel td-period-panel"
                    (onChange)="onPeriodChange($event)"
                    (onHide)="showPeriodCalendar = false">
          <ng-template pTemplate="selectedItem">
            <span>{{ periodLabel }}</span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="td-period-option" *ngIf="option.value === 'all'">
              {{ option.label }}
            </div>
            <div class="td-period-option" *ngIf="option.value === 'custom'"
                 (mouseenter)="showPeriodCalendar = true"
                 (mouseleave)="showPeriodCalendar = false">
              {{ option.label }}
              <i class="bi bi-caret-down-fill td-period-caret" [ngClass]="{'open': showPeriodCalendar}"></i>
              <div class="calendar-container" *ngIf="showPeriodCalendar" (click)="$event.stopPropagation()">
                <p-calendar selectionMode="range" [(ngModel)]="periodRangeDates"
                            [ngModelOptions]="{standalone: true}" [inline]="true"></p-calendar>
                <div class="calendar-footer-container">
                  <span (click)="clearPeriodRange()">{{ 'clear_button' | translate }}</span>
                  <span (click)="cancelPeriodRange()" style="margin-left:auto">{{ 'cancel_button' | translate }}</span>
                  <span (click)="submitPeriodRange()">{{ 'ok_button' | translate }}</span>
                </div>
              </div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>

    <div class="spinner-border text-primary td-spinner" role="status" *ngIf="vm.loading"></div>

    <div class="td-body-container" *ngIf="!vm.loading">
      <app-overall-view *ngIf="view === 'overall'"
                        [overallScore]="vm.overallScore"
                        [periodLabel]="periodLabel"
                        [pyramidCategories]="vm.pyramidCategories"
                        [pyramidLegend]="vm.pyramidLegend"
                        [scoreDevelopment]="vm.scoreDevelopment"
                        [scoreDevelopmentChips]="vm.scoreDevelopmentChips"
                        [activeChipUuid]="activeChipUuid"
                        [loadingScoreDevelopment]="vm.loadingScoreDevelopment"
                        [teamOverview]="vm.teamOverview"
                        [loadingTeamOverview]="vm.loadingTeamOverview"
                        [highlights]="vm.highlights"
                        (chipSelected)="onScoreDevelopmentChip($event)"
                        (categorySelected)="onPyramidCategory($event)"
                        (teamOverviewFiltersChanged)="onTeamOverviewFilters($event)"
                        (highlightDismissed)="onHighlightDismissed($event)">
      </app-overall-view>
      <ng-container *ngIf="view === 'indicator'">
        <app-indicator-view *ngIf="indicatorVm$ | async as indicatorVm"
                            [tabs]="indicatorVm.tabs"
                            [selectedUuid]="indicatorVm.selectedUuid"
                            [detail]="indicatorVm.detail"
                            [loading]="indicatorVm.loading"
                            [scoreDevelopment]="indicatorVm.scoreDevelopment"
                            [statements]="indicatorVm.statements"
                            [loadingStatements]="indicatorVm.loadingStatements"
                            [statementResponses]="indicatorVm.statementResponses"
                            [periodStartDate]="requestPayload.startDate"
                            [periodEndDate]="requestPayload.endDate"
                            [teamVisibility]="indicatorVm.teamVisibility"
                            (categorySelected)="onIndicatorCategory($event)"
                            (statementFiltersChanged)="onStatementFilters($event)"
                            (statementOpened)="onStatementOpened($event)"
                            (visibilityChanged)="onVisibilityChanged($event)">
        </app-indicator-view>
      </ng-container>
    </div>
  </div>
</ng-container>
